<template>
  <div>
    <v-card color="#EDF1F3">
      <v-layout align-center justify-start style="padding-left: 20px">
        <loading-component :value="loading" />
        <v-form ref="form"><img :src="api.GET_COMPANY_IMAGE(null)" class="image" v-if="companyRequest" />

        </v-form>

        <v-flex xs3>
          <div class="headline">
            {{ this.companyRequest.company_name }}
          </div>
          <div style="color: #8599a3">{{ this.companyRequest.email }}</div>
          <div style="color: #8599a3; margin-top: 6px">
            {{ this.companyRequest.phone_number }}
          </div>
        </v-flex>

        <v-flex xs2>
          <v-btn v-if="!companyRequest.approved_at" @click="approve" :loading="loading" style="float: right"
            color="primary" :disabled="disableSaveButton">{{ $t("customers.companyRequestProfile.approve") }}</v-btn>
          <div v-else class="headline" style="float: right; color: #d71010 ;"
          >{{ $t("customers.companyRequestProfile.approved") }}</div>
        </v-flex>

      </v-layout>
    </v-card>

    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <!-- <v-tab :key="1" ripple active-class="tab"> Info </v-tab> -->

      <v-tab-item>
        <v-card height="100%" style="height: 100%; position: absolute; width: 100%">
          <v-layout align-center>
            <v-flex xs6 style="height: 100%; margin-left: 100px">
              <v-card-title primary-title>
                <v-flex xs12 style="margin-bottom: 25px">
                  <div class="headline">{{ $t("customers.companyRequestProfile.information") }}</div>
                </v-flex>
                <table>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.id") }}</th>
                    <td>
                      <span>{{ companyRequest.id }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.companyName") }}</th>
                    <td>
                      <span>{{ companyRequest.company_name }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.contactName") }}</th>
                    <td>
                      <span>{{ companyRequest.contact_name }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.email") }}</th>
                    <td>
                      <span>{{ companyRequest.email }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.phone") }}</th>
                    <td>
                      <span>{{ companyRequest.phone_number }}</span>
                    </td>
                  </tr>

                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.creationDate") }}</th>
                    <td>
                      <span>
                        {{
                          moment(this.companyRequest.created_at).format(
                            "DD MMM YYYY [at] HH:mm a"
                          )
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.additionalInfo") }}</th>
                    <td>
                      <span>{{ companyRequest.info }}</span>
                    </td>
                  </tr>
                </table>
              </v-card-title>
            </v-flex>
            <v-flex xs6 style="height: 100%; margin-left: 100px">
              <v-card-title primary-title>

                <table>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.legalForm") }}</th>
                    <td>
                      <span>{{ companyRequest.legal_form }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.street") }}</th>
                    <td>
                      <span>{{ companyRequest.street }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.no") }}</th>
                    <td>
                      <span>{{ companyRequest.no }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.postalCode") }}</th>
                    <td>
                      <span>{{ companyRequest.postal_code }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.city") }}</th>
                    <td>
                      <span>{{ companyRequest.city }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.rciNo") }}</th>
                    <td>
                      <span>{{ companyRequest.rci_no }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.companyRequestProfile.rciExtract") }}</th>
                    <td>
                      <span><b><a href="#" @click="openRCI()">{{ $t("customers.companyRequestProfile.open") }}</a></b></span>
                    </td>
                  </tr>
                </table>
              </v-card-title>
            </v-flex>
          </v-layout>

        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "CompanyRequest",
  title() {
    return this.$t("customers.companyRequestProfile.title");
  },
  components: {
    LoadingComponent,
  },

  data() {
    return {
      companyRequest: null,
      loading: true
    };
  },
  mounted() {
    this.axios.get(`company-request/${this.$route.params.id}`).then(({ data }) => {
      this.companyRequest = data.data;

      this.loading = false;

    });
  },
  methods: {
    openRCI() {
      this.axios.get(`company-request-file/${this.$route.params.id}`, { responseType: 'blob' }).then((res) => {

        const href = URL.createObjectURL(res.data);

        const link = document.createElement("a");
        link.href = href;
        link.innerHTML = " download";
        link.setAttribute("download", this.companyRequest.company_name + ".pdf");
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      }).finally(() => {
      });
    },

    approve() {

      this.loading = true;
      this.axios
        .put(`company-request/${this.$route.params.id}/approve`)
        .then((data) => {
          this.companyRequest.approved_at = data.data.data.approved_at || null;
          this.loading = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", [
            "bottom",
            "left",
          ]);
        });
    },
  },
  computed: {
    today() {
      return moment().format("YYYY-MM-DD");
    },
    disableSaveButton() {
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  background-color: #ffffff !important;
}

.docs:hover {
  cursor: pointer;
}

.star {
  color: #f3c220;
}

.image {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin-right: 17px;
  margin-top: 10px;
}

.image:hover {
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  cursor: pointer;
}

.tab {
  color: #e21024 !important;
}

.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

.companyRequests-list {
  width: 100%;
  margin-left: 90px;
  z-index: 7;
  max-height: 100px;
  min-height: 100px;
  float: left;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.companyRequest {
  width: max-content;
  float: left;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  cursor: pointer;

  img {
    height: 32px;
    width: 32px;
    float: left;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }
}

.car {
  color: #7e939c;
}

.open {
  margin-bottom: 15px;
  margin-left: 35px;
}

.constraints.v-label {
  font-size: xx-large !important;
}

table {
  max-width: 500px;
  width: 500px;

  tr {

    th,
    td {
      padding: 0 12px;
      text-align: left;

      span {
        padding: 16px 0;
        float: left;
      }
    }

    th {
      padding-left: 0;
    }

    td {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      gap: 14px;
      max-width: 350px;
      width: 350px;
    }
  }
}
</style>
